
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.776 18.107l-.75-1.834a.148.148 0 00-.216-.07l-1.684 1.043c-1.094.677-2.46-.316-2.155-1.565l.471-1.925a.148.148 0 00-.133-.184l-1.976-.146C.051 13.33-.472 11.724.51 10.893l1.513-1.28a.148.148 0 000-.226L.51 8.107c-.981-.831-.46-2.438.823-2.533l1.976-.147a.148.148 0 00.133-.183l-.47-1.925c-.307-1.249 1.06-2.242 2.154-1.565L6.81 2.797a.148.148 0 00.216-.07l.75-1.834c.487-1.19 2.176-1.19 2.663 0l.75 1.834a.148.148 0 00.216.07l1.684-1.043c1.094-.677 2.46.316 2.155 1.565l-.471 1.925a.148.148 0 00.133.183l1.976.147c1.282.095 1.805 1.701.823 2.532l-1.513 1.28a.148.148 0 000 .227l1.513 1.28c.984.833.457 2.438-.823 2.533l-1.976.146a.149.149 0 00-.133.184l.47 1.925c.307 1.249-1.06 2.242-2.154 1.565l-1.684-1.043a.149.149 0 00-.216.07l-.75 1.834c-.488 1.194-2.177 1.187-2.663 0zm.624-2.396l.707 1.73.708-1.73a1.633 1.633 0 012.37-.77l1.59.983-.444-1.815a1.633 1.633 0 011.465-2.017l1.864-.138-1.427-1.208a1.633 1.633 0 010-2.493l1.427-1.207-1.864-.138A1.633 1.633 0 0113.33 4.89l.444-1.815-1.59.983c-.858.532-1.988.163-2.37-.77l-.708-1.73-.707 1.73a1.633 1.633 0 01-2.37.77l-1.59-.983.444 1.815c.24.981-.459 1.942-1.465 2.017l-1.864.138 1.427 1.207c.771.653.77 1.842 0 2.493l-1.427 1.208 1.864.138a1.633 1.633 0 011.465 2.017l-.444 1.815 1.59-.983a1.633 1.633 0 012.37.77zm.708-1.461c-2.62 0-4.75-2.13-4.75-4.75s2.13-4.75 4.75-4.75c2.619 0 4.75 2.13 4.75 4.75s-2.131 4.75-4.75 4.75zm0-7.719A2.972 2.972 0 006.139 9.5a2.972 2.972 0 002.969 2.969A2.972 2.972 0 0012.076 9.5a2.972 2.972 0 00-2.968-2.969z","fill":"currentColor"}})])
          )
        }
      }
    